import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

// @ts-expect-error
import {DateTimeInputTextfield} from '../date-time-picker/date-time-input-textfield';
import {FormField} from '../form/form-field';

type OwnProps = {
    title?: string;
    placeholder?: string;
    helperText?: string;
    isRequired?: boolean;
    shouldOmitTime?: string;
    persistOnSelect?: boolean;
};

type Props = FieldProps & OwnProps;

export function ReduxFormDateTime({
    title,
    helperText,
    isRequired,
    input,
    meta,
    shouldOmitTime,
    persistOnSelect,
    ...restProps
}: Props) {
    return (
        <FormField
            innerId={input.name}
            label={title}
            helperText={helperText}
            errorMessage={meta.error && meta.submitFailed ? meta.error : null}
            isRequired={isRequired}
        >
            <DateTimeInputTextfield
                {...input}
                {...restProps}
                shouldOmitTime={shouldOmitTime}
                displayFormat={shouldOmitTime ? 'dddd, MMMM Do, YYYY' : undefined}
                persistOnSelect={persistOnSelect}
            />
        </FormField>
    );
}
